<template>
  <vs-popup
    id="referralDetailModal"
    :active.sync="popupActive"
    fullscreen
    title="Mood İşlem & Referans Detay Raporu"
  >
    <div v-if="loading" class="p-8 text-center">
      <vs-progress indeterminate color="primary"></vs-progress>
      <p class="mt-4 text-primary weight-600">İşlem detayları yükleniyor...</p>
    </div>

    <div v-else-if="detail" class="p-4">
      <!-- Top Cards Row: Transaction Summary & Executing Customer Profile -->
      <div class="vx-row mb-6">
        <!-- 1. KART: İşlem Nedeni & Detayları -->
        <div class="vx-col w-full md:w-1/2 mb-4 md:mb-0">
          <vx-card title="1. İşlem Nedeni & Detayları" class="h-full">
            <div class="flex items-center justify-between mb-3 pb-2 border-b">
              <span class="text-grey font-semibold">İşlem Nedeni & Başlığı:</span>
              <vs-chip :color="transaction && (transaction.isNegative || transaction.type == 2) ? 'danger' : (transaction && transaction.type == 1 ? 'warning' : 'success')" class="weight-600">
                {{ transaction ? (transaction.displayTitle || (transaction.type == 0 ? '+ Mood Kazanma (Referans Daveti)' : (transaction.product ? transaction.product.name : 'Mood İşlemi'))) : '-' }}
              </vs-chip>
            </div>
            <div class="flex items-center justify-between mb-3 pb-2 border-b">
              <span class="text-grey font-semibold">Şube:</span>
              <span class="weight-600 text-dark">{{ transaction && transaction.branch ? transaction.branch.name : '-' }}</span>
            </div>
            <div class="flex items-center justify-between mb-3 pb-2 border-b">
              <span class="text-grey font-semibold">Ürün / Açıklama:</span>
              <span class="weight-600 text-dark">
                {{ transaction && transaction.product ? transaction.product.name : (transaction && transaction.type == 0 ? 'Arkadaş Daveti Bonusu' : '-') }}
              </span>
            </div>
            <div class="flex items-center justify-between mb-3 pb-2 border-b">
              <span class="text-grey font-semibold">Finansal Karşılık / Maliyet:</span>
              <span class="weight-700 text-warning">{{ transaction ? $toCurrency(transaction.amount) : '-' }}</span>
            </div>
            <div class="flex items-center justify-between">
              <span class="text-grey font-semibold">İşlem Tarihi & Saati:</span>
              <span class="weight-600 text-dark">{{ transaction ? transaction.date + ' ' + transaction.time : '-' }}</span>
            </div>
          </vx-card>
        </div>

        <!-- 2. KART: İşlemi Yapan Müşteri Profili -->
        <div class="vx-col w-full md:w-1/2">
          <vx-card title="2. İşlemi Yapan (Puanı Kazanan / Harcayan) Müşteri Profili" class="h-full">
            <div class="flex items-center justify-between mb-3 pb-2 border-b">
              <span class="text-grey font-semibold">Müşteri Adı Soyadı:</span>
              <span class="weight-600 text-dark">{{ (detail.customerInfo.name || '') + ' ' + (detail.customerInfo.surname || '') }}</span>
            </div>
            <div class="flex items-center justify-between mb-3 pb-2 border-b">
              <span class="text-grey font-semibold">Telefon (İşlemi Yapan):</span>
              <span class="weight-700 text-dark">{{ detail.customerInfo.phone || '-' }}</span>
            </div>
            <div class="flex items-center justify-between mb-3 pb-2 border-b">
              <span class="text-grey font-semibold">E-posta:</span>
              <span class="weight-600 text-dark">{{ detail.customerInfo.email || '-' }}</span>
            </div>
            <div class="flex items-center justify-between">
              <span class="text-grey font-semibold">Bu İşlemden Kazandığı / Harcadığı Mood:</span>
              <vs-chip :color="transaction && (transaction.isNegative || transaction.type == 2) ? 'danger' : 'success'" class="weight-700 text-base px-3">
                {{ transaction ? (transaction.quantityFormatted || (transaction.type == 2 ? '-' + transaction.quantity + ' Mood' : '+' + transaction.quantity + ' Mood')) : '-' }}
              </vs-chip>
            </div>
          </vx-card>
        </div>
      </div>

      <!-- 3. KART: Davet Eden (Referans Gösterilen) Üst Müşteri Bilgisi -->
      <div v-if="detail.invitedByInfo" class="vx-row mb-4">
        <div class="vx-col w-full">
          <vx-card title="3. Referans Gösterilen (Davet Eden) Müşteri Bilgisi" class="border border-solid border-warning">
            <div class="vx-row items-center">
              <div class="vx-col w-full md:w-1/3 mb-2 md:mb-0">
                <span class="text-grey font-semibold block mb-1">Davet Eden Müşteri:</span>
                <span class="weight-700 text-dark">
                  {{ (detail.invitedByInfo.name || detail.invitedByInfo.surname) ? ((detail.invitedByInfo.name || '') + ' ' + (detail.invitedByInfo.surname || '')) : 'İsim Belirtilmemiş' }}
                </span>
              </div>
              <div class="vx-col w-full md:w-1/3 mb-2 md:mb-0">
                <span class="text-grey font-semibold block mb-1">Telefon (Referans Numara):</span>
                <vs-chip color="warning" class="font-mono weight-700 text-base px-3">{{ detail.invitedByInfo.phone || '-' }}</vs-chip>
              </div>
              <div class="vx-col w-full md:w-1/3">
                <span class="text-grey font-semibold block mb-1">Davet Sebebiyle Kazandığı Mood Ödülü:</span>
                <vs-chip color="success" class="weight-700 text-base px-3">+{{ detail.invitedByInfo.earnedMoodFromInvite || 2 }} Mood</vs-chip>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { GetReferralDetail } from "@/api/Reports";

export default {
  name: "ReferralDetailModal",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: String,
      default: null,
    },
    transaction: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loading: false,
      detail: null,
    };
  },
  computed: {
    popupActive: {
      get() {
        return this.active;
      },
      set(val) {
        this.$emit("update:active", val);
      },
    },
  },
  watch: {
    active(val) {
      if (val && this.customerId) {
        this.fetchDetail();
      }
    },
    customerId(val) {
      if (val && this.active) {
        this.fetchDetail();
      }
    },
  },
  methods: {
    fetchDetail() {
      if (!this.customerId) return;
      this.loading = true;
      this.detail = null;
      GetReferralDetail(this.customerId)
        .then((res) => {
          this.loading = false;
          if (res && res.status === 200) {
            this.detail = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata",
              text: "Referans detayları alınamadı.",
            });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: "Sunucu bağlantı hatası.",
          });
        });
    },
  },
};
</script>

<style scoped>
.font-mono {
  font-family: monospace;
}
</style>
